import styled from "styled-components";
import {ReactComponent as SVG} from '../icons/edit.svg'
import { color } from "../theme/standardTheme";

const EditIcon = styled(SVG)`
    path {
        stroke: ${props => props.color? props.color : color.font}; 
    };
    display: inline; 
    justify-self: center; 
    align-self: center;
    height: 20px;
    width: 20px; 
`
export default EditIcon;